import axios from '../../config/axios';
import apiPaths from '../apiPaths';

const onGetInsuredRisks = (params) => axios.get(apiPaths.insuredRisksBase, { params });

const onGetInsuredRisk = (id) => axios.get(`${apiPaths.insuredRisksBase}/${id}`);

export { onGetInsuredRisks, onGetInsuredRisk };
